// extracted by mini-css-extract-plugin
export default {"characterInfoItem":"CharacterInfoItem_characterInfoItem__anN2M","item":"CharacterInfoItem_item__aU8n8","titles":"CharacterInfoItem_titles__cniZH"};